import { render, staticRenderFns } from "./FactorialMaterialExportModal.vue?vue&type=template&id=2b33c755&scoped=true&"
import script from "./FactorialMaterialExportModal.vue?vue&type=script&lang=js&"
export * from "./FactorialMaterialExportModal.vue?vue&type=script&lang=js&"
import style0 from "./FactorialMaterialExportModal.vue?vue&type=style&index=0&id=2b33c755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33c755",
  null
  
)

component.options.__file = "FactorialMaterialExportModal.vue"
export default component.exports